import React, { createContext, useContext } from 'react';
import { Box, ThemeContext } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import styled from 'styled-components';

// Inside a panel a ChartCard draws as a column, without a border of its own
export const ChartPanelContext = createContext(false);
export const useInPanel = () => useContext(ChartPanelContext);

// Wide enough for three columns at 340px
const COLUMNS = '1060px';

const Wrap = styled.div`container-type: inline-size;`;

// One column per card that renders: a card that returns null leaves no gap. Stacked when narrow.
const Columns = styled.div`
    display: grid;
    & > * + * { border-top: 1px solid ${(props) => props.$line}; }
    /* Stacked, the cards get more room either side of the line between them: a card's own
       medium padding is 24px. Doubled & so this wins over the Box's padding. */
    && > *:not(:first-child) { padding-top: 32px; }
    && > *:not(:last-child) { padding-bottom: 32px; }

    @container (min-width: ${COLUMNS}) {
        grid-auto-flow: column;
        grid-auto-columns: minmax(0, 1fr);
        & > * + * { border-top: none; border-left: 1px solid ${(props) => props.$line}; }
        && > *:not(:first-child), && > *:not(:last-child) { padding-top: 24px; padding-bottom: 24px; }
    }
`;

// No frame at all when every card in it renders nothing, rather than an empty bordered box
const Frame = styled(Box)`
    &:has(> div > div:empty) { display: none; }
`;

// Several related cards in one frame, so they line up however long each one is
const ChartPanel = ({ children }) => {
    const theme = useContext(ThemeContext);
    return (
        <Frame round="xsmall" border elevation="medium" background="background">
            <Wrap>
                <Columns $line={normalizeColor('border-weak', theme)}>
                    <ChartPanelContext.Provider value>{children}</ChartPanelContext.Provider>
                </Columns>
            </Wrap>
        </Frame>
    );
};

export default ChartPanel;
